import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { WhatsAppButton } from "../components/WhatsAppButton";
import { CookieConsent } from "../components/CookieConsent";
import { PageHeader } from "../components/PageHeader";
import { About } from "../components/sections/About";
import { Services } from "../components/sections/Services";
import { ShippingRoutes } from "../components/sections/ShippingRoutes";
import { WhyChooseUs } from "../components/sections/WhyChooseUs";
import { FAQ } from "../components/sections/FAQ";
import { Contact } from "../components/sections/Contact";
import { QuoteForm } from "../components/sections/QuoteForm";
import { AutoSales } from "../components/sections/AutoSales";
import { CtaBanner } from "../components/CtaBanner";
import { useSeo } from "../hooks/useSeo";

const Layout = ({ children, testid, seo, header }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useSeo(seo);
  return (
    <div className="App min-h-screen bg-white" data-testid={testid}>
      <Navbar solid />
      <main className="pt-16">
        <PageHeader {...header} testid={`${testid}-header`} />
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
};

export const AboutPage = () => (
  <Layout
    testid="about-page"
    seo={{
      title: "About R.O.K Motors – Trusted USA to Ghana Shipping Company",
      description: "Learn about R.O.K Motors, a trusted logistics partner shipping vehicles, containers and cargo from the USA to Ghana with reliable, secure and affordable service.",
      path: "/about",
    }}
    header={{ eyebrow: "Who We Are", title: "About R.O.K Motors", subtitle: "Your reliable partner for shipping vehicles, containers and cargo from the USA to Ghana." }}
  >
    <About />
    <CtaBanner />
  </Layout>
);

export const ServicesPage = () => (
  <Layout
    testid="services-page"
    seo={{
      title: "Shipping Services – Cars, Containers & Cargo to Ghana | R.O.K Motors",
      description: "Explore R.O.K Motors shipping services: vehicle shipping, container freight, consolidated cargo, customs clearance and door-to-port delivery from the USA to Ghana.",
      path: "/services",
    }}
    header={{ eyebrow: "What We Do", title: "Our Shipping Services", subtitle: "End-to-end vehicle, container and cargo shipping solutions from America to Ghana." }}
  >
    <Services />
    <CtaBanner />
  </Layout>
);

export const RoutesPage = () => (
  <Layout
    testid="routes-page"
    seo={{
      title: "Shipping Routes – USA to Tema Port, Ghana | R.O.K Motors",
      description: "View R.O.K Motors shipping routes and transit times from major US ports to Tema Port, Ghana. Reliable ocean freight schedules for cars and cargo.",
      path: "/routes",
    }}
    header={{ eyebrow: "Where We Ship", title: "Shipping Routes", subtitle: "Regular sailings from the USA to Tema Port, Ghana with dependable transit times." }}
  >
    <ShippingRoutes />
    <CtaBanner />
  </Layout>
);

export const WhyUsPage = () => (
  <Layout
    testid="why-us-page"
    seo={{
      title: "Why Choose R.O.K Motors – Reliable USA to Ghana Shipping",
      description: "Discover why customers trust R.O.K Motors for shipping to Ghana: transparent pricing, real-time tracking, secure handling and dedicated customer support.",
      path: "/why-us",
    }}
    header={{ eyebrow: "Our Advantage", title: "Why Choose Us", subtitle: "Transparent pricing, secure handling and real-time tracking on every shipment." }}
  >
    <WhyChooseUs />
    <CtaBanner />
  </Layout>
);

export const FaqPage = () => (
  <Layout
    testid="faq-page"
    seo={{
      title: "Frequently Asked Questions – Shipping to Ghana | R.O.K Motors",
      description: "Answers to common questions about shipping cars, containers and cargo from the USA to Ghana with R.O.K Motors, including pricing, transit times and customs.",
      path: "/faq",
    }}
    header={{ eyebrow: "Need Help?", title: "Frequently Asked Questions", subtitle: "Everything you need to know about shipping with R.O.K Motors." }}
  >
    <FAQ />
    <CtaBanner />
  </Layout>
);

export const CarsPage = () => (
  <Layout
    testid="cars-page"
    seo={{
      title: "Cars for Sale – Quality US Vehicles Shipped to Ghana | R.O.K Motors",
      description: "Browse quality US vehicles for sale by R.O.K Motors — sedans, SUVs, pickups and more, shipped straight to Tema Port, Ghana. Filter by price, body type and fuel.",
      path: "/cars",
    }}
    header={{ eyebrow: "Auto Sales", title: "Vehicles for Sale", subtitle: "Hand-picked clean US vehicles — buy and we'll ship it straight to Tema Port, Ghana." }}
  >
    <AutoSales embedded />
    <CtaBanner />
  </Layout>
);


export const ContactPage = () => (
  <Layout
    testid="contact-page"
    seo={{
      title: "Contact R.O.K Motors – Get a Free Shipping Quote to Ghana",
      description: "Contact R.O.K Motors for a free quote on shipping vehicles, containers or cargo from the USA to Ghana. Call, WhatsApp or email our team today.",
      path: "/contact",
    }}
    header={{ eyebrow: "Get In Touch", title: "Contact Us", subtitle: "Reach out for a free quote or any questions about shipping to Ghana." }}
  >
    <Contact />
    <QuoteForm />
  </Layout>
);
